export const loadScripts = async (carouselBool) => {
    // Jump Links
    if (document.querySelector(".look-for-jumplinks .jump-link-nav") || document.querySelector(".page-class-insights .jump-link-nav")) {
        await import("../../../../us/js/src/insights/populate-jumplink-nav.js");
    }

    if (document.querySelector(".charts-above-the-fold")) {
        // Highcharts Block
        if (document.querySelector(".highcharts-block-js")) {
            await import("../../../../us/js/src/highcharts-block.js");
        }

        // Performance Charts (highcharts)
        if (document.querySelector(".performance-chart-block-js")) {
            await import("../../../../eu/js/src/sources/performance-charts.js");
        }
    }

    // Carousels
    // if (document.querySelector(".carousels-above-the-fold") && carouselBool) {
        await import("./carousels.js");
    // }
}

export const loadScrollDelayedScripts = async (carouselBool) => {
    // Expandable Nav
    if (document.querySelector("ve-expandablemenu") && !window.ExpandableMenu) {
        window.ExpandableMenu = true;
        await import("../override/expandable-menu/expandable-nav.js");
    }

    if (!document.querySelector(".charts-above-the-fold")) {
        // Highcharts Block
        if (document.querySelector(".highcharts-block-js")) {
            await import("../../../../us/js/src/highcharts-block.js");
        }

        // Performance Charts (highcharts)
        if (document.querySelector(".performance-chart-block-js")) {
            await import("../../../../eu/js/src/sources/performance-charts.js");
        }
    }

    // Carousels
    if (!document.querySelector(".carousels-above-the-fold") && carouselBool) {
        await import("./carousels.js");
    }
}

export const loadHeaderSearch = async () => {
    await import("../override/search.js");
}